

















import { Vue, Watch, Prop, Component } from 'vue-property-decorator'
import Banner from '@/components/Banner.vue'

@Component({
  components: {
    Banner
  }
})
export default class NewsDetail extends Vue {
  navigation = [
    {
      text: '首页',
      path: '/'
    },
    {
      text: '新闻',
      path: '/news'
    },
    {
      text: '新闻',
      path: '/news'
    },
    {
      text: '名字',
      path: ''
    }
  ]
  newDetail:any = {}

  get queryYear () {
    let year = this.$route.query.year
    return year
  }
  updated () {
    this.resetStyle()
  }

  mounted () {
    this.changeRoute()
    console.log('queryYear', this.queryYear)
    console.log('id', this.$route.query.id)
    this.$store.dispatch('getNewDetail', { id: this.$route.query.id }).then(res => {
      console.log('新闻详情页面', res)
      this.newDetail = res.detail
      console.log('详情', this.newDetail)
      console.log('=====》', this.navigation[3])
      this.navigation[3].text = this.newDetail.title
    })
  }
  @Watch('$route')
  onRouteChanged () {
    this.changeRoute()
  }
  changeRoute () {
    console.log(this.$route)
    this.navigation.forEach((item:any, index:number) => {
      if (index === 2) {
        item.text = this.queryYear
        item.path = '/news?year=' + this.queryYear
      }
    })
  }
  resetStyle () {
    $('#detailMain').css('line-height', '22px')
    $('#detailMain').find('p,span').css({
      'font-size': '16px',
      'line-height': '28px',
      'font-family': "'Microsoft YaHei','PingFang SC','Hiragino Sans GB',Helvetica,Tahoma,Arial,SimSun,Heiti,sans-serif",
      'word-wrap': 'break-word',
      'letter-spacing': '1px'
    })
    $('#detailMain').find('img').css({
      'width': '720px',
      'height': 'auto',
      'max-width': '100%',
      'vertical-align': 'middle',
      'border': '0'
    })
    $('#detailMain').find('p>h3').css({
      'display': 'block',
      'text-align': 'center'
    })
    $('#detailMain').find('a').css({
      'color': '#0088cc',
      'text-decoration': 'none'
    })
    $('#detailMain').find('a:hover').css({
      'color': '#2A9FE4'
    })
  }
}
